import { render, staticRenderFns } from "./handover_dialog.vue?vue&type=template&id=51b85274&scoped=true"
import script from "./handover_dialog.vue?vue&type=script&lang=js"
export * from "./handover_dialog.vue?vue&type=script&lang=js"
import style0 from "./handover_dialog.vue?vue&type=style&index=0&id=51b85274&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b85274",
  null
  
)

export default component.exports